// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__JkKwb","inputWrap":"Table_inputWrap__2uvwb","col":"Table_col__3dPpW","bmiTooltip":"Table_bmiTooltip__2HUdh"};